/* Colours come from --nexus-qr-dark / --nexus-qr-light, which are
   mode-independent: a QR code must never invert in dark mode — many scanners
   cannot read light-on-dark. The light rect carries the quiet zone, so the
   symbol scans even when it sits on a dark surface. */
.qr {
  display: inline-block;
  width: var(--qr-size);
  height: var(--qr-size);
  line-height: 0;
  flex-shrink: 0;
}

.svg {
  display: block;
  width: var(--qr-size);
  height: var(--qr-size);
}

.light {
  fill: var(--nexus-qr-light);
}

.dark {
  fill: var(--nexus-qr-dark);
}
